<template>
  <g class="axis-wrapper">
    <g class="axis axis-y" />

    <text
      v-if="showLabel && !disabled"
      :y="type === 'percentage' ? -45 : -57"
      :x="0-(height/2)"
      transform="rotate(-90)"
      class="label"
    >
      {{ label }}
    </text>
  </g>
</template>

<script>
import d3 from '@/analytics/importers/d3-importer'

const props = {
  scaleY: {},
  ceil: {
    type: Number,
  },
  width: {
    type: Number,
  },
  height: {
    type: Number,
  },
  showLabel: {
    type: Boolean,
    default: true,
  },
  type: {
    type: String,
    default: 'line',
  },
  disabled: {
    type: Boolean,
  },
}

// Component for Y axis
export default {
  name: 'AxisY',
  props: props,
  data () {
    return {
      labels: {
        line: 'reads / views',
        barchartArticle: 'reads / views / downloads',
        barchartNewsletter: 'opens / reads / clicks',
        percentage: 'percentage',

      },
    }
  },
  computed: {
    label () {
      return this.labels[this.type]
    },
  },
  watch: {
    width () {
      this.drawYaxis()
    },
    scaleY () {
      this.drawYaxis()
    },
  },
  mounted () {
    this.drawYaxis()
  },
  methods: {
    drawYaxis () {
      const that = this

      let axisLeft = null
      if (this.type === 'percentage') {
        axisLeft = d3.axisLeft(this.scaleY).tickValues([0, 25, 50, 75, 100])
      } else {
        axisLeft = d3.axisLeft(this.scaleY).ticks(Math.min(6, this.ceil))
      }

      const g = d3.select(this.$el).select('.axis-y')
          .call(axisLeft)

      g.select('.domain').attr('opacity', '0')
      g.selectAll('.tick line')
          .attr('x2', that.width)
          .attr('stroke', '#c2c7d9')
          .attr('stroke-dasharray', '1,1')

      g.selectAll('.tick:first-of-type line')
          .attr('stroke-dasharray', '0')

      g.selectAll('.tick text')
          .attr('font-family', 'GT Cinetype Mono, Helvetica, Roboto, Arial, sans-serif')
          .attr('letter-spacing', '1.1px')
    },
  },
}
</script>

<style lang="scss">
  .axis-wrapper {

    .label {

      text-anchor: middle;
      color: #1f2638;
      text-transform: uppercase;
      font-family: GT Cinetype Mono, Helvetica, Roboto, Arial, sans-serif;
      letter-spacing: 1.1px;
    }
  }
</style>
